module.exports = __webpack_public_path__ + "img/Jeffrey.c047ac79.jpg";